import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export interface ProductUrlParameters {
  token: string | undefined;
  brandToken: string | undefined;
  impressionId: string | undefined;
  selectedProductOptionToken: string | undefined;
}

export const productUrlParametersILeanProductTileAdapter = (
  productTile: ILeanProductTile
): ProductUrlParameters => {
  return {
    token: productTile.product?.token,
    brandToken: productTile.product?.brand_token,
    impressionId: productTile.product?.impression_id,
    selectedProductOptionToken: productTile.selected_product_option_token,
  };
};
